import React from 'react'

import s from './styles.module.scss'

import { Icon } from '../../../../atoms'

type ArticleHeaderProps = {
  title: string
  author?: {
    name: string
  }
  createdAt?: string
  readTimeMinute: number
}

const options: Intl.DateTimeFormatOptions = {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
}

export const ArticleHeader = ({
  title,
  author,
  createdAt,
  readTimeMinute,
}: ArticleHeaderProps) => {
  return (
    <header className={s.articleHeader}>
      <h1 className={s.title}>{title}</h1>
      <div className={s.information}>
        {author?.name && (
          <>
            <span>{author.name}</span>
            <Icon name='dot' size={7} />
          </>
        )}
        {createdAt && (
          <>
            <span>
              {new Date(createdAt)
                .toLocaleDateString('fr', options)
                .split(' ')
                .slice(1)
                .join(' ')}
            </span>
            <Icon name='dot' size={7} />
          </>
        )}
        {/* TODO: Translate */}
        <span>{Math.ceil(readTimeMinute)} min environ</span>
      </div>
    </header>
  )
}
